import type { MeasurementUnit } from './units'

type UnitLabels = {
  short: string
  long: string
  acronym: string
}

export type UnitLabelFormat = keyof UnitLabels

const UNIT_LABELS: Readonly<Record<string, UnitLabels>> = {
  'm/s': { short: 'm/s', long: 'meters/second', acronym: 'm/s' },
  'cm/s': { short: 'cm/s', long: 'centimeters/second', acronym: 'cm/s' },
  'm/min': { short: 'm/min', long: 'meters/minute', acronym: 'm/min' },
  'feet/s': { short: 'ft/s', long: 'feet/second', acronym: 'ft/s' },
  'inches/s': { short: 'in/s', long: 'inches/second', acronym: 'in/s' },
  'feet/min': { short: 'ft/min', long: 'feet/minute', acronym: 'ft/min' },

  m: { short: 'm', long: 'meters', acronym: 'm' },
  meters: { short: 'm', long: 'meters', acronym: 'm' },
  cm: { short: 'cm', long: 'centimeters', acronym: 'cm' },
  feet: { short: 'ft', long: 'feet', acronym: 'ft' },
  inches: { short: 'in', long: 'inches', acronym: 'in' },
  inch: { short: 'in', long: 'inch', acronym: 'in' },

  kg: { short: 'kg', long: 'kilograms', acronym: 'kg' },
  pounds: { short: 'lbs', long: 'pounds', acronym: 'lbs' },

  sec: { short: 'sec', long: 'seconds', acronym: 's' },
  seconds: { short: 'sec', long: 'seconds', acronym: 's' },

  '%': { short: '%', long: '%', acronym: '%' },
  degrees: { short: 'deg', long: 'degrees', acronym: '°' },
  'degrees/sec': { short: 'deg/s', long: 'degrees/second', acronym: '°/s' },
  ratio: { short: 'ratio', long: 'ratio', acronym: 'ratio' },

  'steps/min': { short: 'steps/min', long: 'steps per minute', acronym: 'spm' },
  'stairs/min': { short: 'stairs/min', long: 'stairs per minute', acronym: 'stairs/min' },

  '(m/s^2)^2': { short: '(m/s²)²', long: '(meters/second²)²', acronym: '(m/s²)²' },
  '(m/s^2)^3': { short: '(m/s²)³', long: '(meters/second²)³', acronym: '(m/s²)³' },

  repetitions: { short: 'reps', long: 'repetitions', acronym: 'reps' },
  count: { short: 'count', long: 'count', acronym: 'ct' },
} satisfies Record<MeasurementUnit, UnitLabels>

export function unitDisplayLabel(unit: MeasurementUnit, format?: UnitLabelFormat): string
export function unitDisplayLabel(unit: string | null | undefined, format?: UnitLabelFormat): string | undefined
export function unitDisplayLabel(unit: string | null | undefined, format: UnitLabelFormat = 'short') {
  return unit ? UNIT_LABELS[unit]?.[format] : undefined
}
